import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { compose, indexOf, prop, sortBy, __ } from 'ramda';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { ColumnType } from '../api/generated';
import { apiColumnToTableColumn } from '../api/helpers';
import { useColumnsVisibility } from './useColumnsVisibility';
const maxNumberIfMinusOne = (number) => (number === -1 ? Number.MAX_SAFE_INTEGER : number);
const sortDataArray = (dataArray, order, sortProp) => 
// @ts-expect-error "It works, but ramda types are not correctly inferred"
sortBy(compose(maxNumberIfMinusOne, indexOf(__, order), prop(sortProp)))(dataArray);
const createIndexColumn = () => apiColumnToTableColumn({
    isId: false,
    dataType: ColumnType.Number,
    isArray: false,
    fieldName: 'index',
    fieldKey: 'index',
    isInsertable: false,
    isUiEditable: false,
    isUploadEditable: false,
    renderHeader: () => (_jsxs("b", { children: [_jsx(FormattedMessage, { id: "fieldName.index", defaultMessage: "index" }), ' '] })),
});
export const useColumns = (options) => {
    const { tableKey, columns, order, defaultHiddenColumns } = options;
    const allColumns = useMemo(() => sortDataArray([createIndexColumn(), ...columns], order, 'fieldName'), [columns, order]);
    const { isColumnVisible, setAllColumnsHidden, setAllColumnsVisible, setColumnVisibility, toggleColumnVisibility } = useColumnsVisibility(tableKey, allColumns, defaultHiddenColumns);
    const visibleColumns = useMemo(() => allColumns.filter((column) => !column.isFilterOnly && isColumnVisible(column)), [allColumns, isColumnVisible]);
    return {
        allColumns,
        visibleColumns,
        isColumnVisible,
        setAllColumnsHidden,
        setAllColumnsVisible,
        setColumnVisibility,
        toggleColumnVisibility,
    };
};
//# sourceMappingURL=useColumns.js.map